import React, { useEffect, useState } from "react";
import { fetchCategories, fetchGallery, resolveMediaUrl } from "../../api/galleryApi";

function GalleryPhotos() {
  const [categories, setCategories] = useState([]);
  const [toggleState, setToggleState] = useState("");
  const [CategoryName, setCategoryName] = useState("");
  const [pageIndex, setPageIndex] = useState(0);
  const pageSize = 10;
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const displayed = items;
  const hasNext = (pageIndex + 1) * pageSize < total;
  const hasPrev = pageIndex > 0;

  useEffect(() => {
    let mounted = true;
    (async () => {
      const data = await fetchCategories();
      const photoCats = data.imageCategories || [];
      if (!mounted) return;
      setCategories(photoCats);
      const initial = photoCats[0] || "";
      setToggleState(initial);
      setCategoryName(initial);
    })().catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    setPageIndex(0);
  }, [CategoryName]);

  useEffect(() => {
    if (!CategoryName) return;
    let mounted = true;
    (async () => {
      const res = await fetchGallery({
        type: "image",
        category: CategoryName,
        page: pageIndex + 1,
        limit: pageSize,
      });
      if (!mounted) return;
      setItems(res.items || []);
      setTotal(res.total || 0);
    })().catch(() => {});
    return () => {
      mounted = false;
    };
  }, [CategoryName, pageIndex]);

  const toggleTab = (category) => {
    setToggleState(category);
    setCategoryName(category);
  };

  return (
    <div className="mt-8">
      <div className="flex flex-wrap justify-center gap-7">
        {categories.map((cat) => (
          <button
            key={cat}
            className={
              toggleState === cat
                ? "text-[#45b3df] font-bold text-2xl"
                : "text-[#fa9db7] font-bold text-2xl"
            }
            onClick={() => toggleTab(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-5 pt-12">
        {displayed.map((img) => (
          <div key={img.id} className="rounded-xl overflow-hidden">
            <img src={resolveMediaUrl(img.file_url)} className="w-full" alt="" />
          </div>
        ))}
      </div>

      <div className="flex justify-center gap-5 py-6">
        <button
          onClick={() => setPageIndex((p) => Math.max(0, p - 1))}
          disabled={!hasPrev}
          className="px-4 py-2 bg-gray-300 rounded disabled:opacity-40"
        >
          Previous
        </button>

        <button
          onClick={() => setPageIndex((p) => p + 1)}
          disabled={!hasNext}
          className="px-4 py-2 bg-blue-500 text-white rounded disabled:opacity-40"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default GalleryPhotos;
